import { ICalculateResult } from '../../types/calculate';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ECalculateActionType {
  Loading = 'calculate/fetchCalculate/loading',
  Succeed = 'results/fetchCalculate/succeed',
  Failed = 'results/fetchCalculate/failed',
}

export type TCalculateLoading = ITypedReduxAction<ECalculateActionType.Loading>;
export type TCalculateSucceed = ITypedReduxAction<ECalculateActionType.Succeed, ICalculateResult>;
export type TCalculateFailed = ITypedReduxAction<ECalculateActionType.Failed, string>;

export type TCalculateActions = TCalculateLoading | TCalculateSucceed | TCalculateFailed;
